import React, { useState } from "react";
import Login from "./components/Login";
import Dashboard from "./components/Dashboard";

function App() {
  const [patient, setPatient] = useState(null);

  return (
    <div>
      {patient ? <Dashboard patient={patient} /> : <Login setPatient={setPatient} />}
    </div>
  );
}

export default App;
